import { render, staticRenderFns } from "./VoiceRecorder.vue?vue&type=template&id=1986d224&scoped=true&"
import script from "./VoiceRecorder.vue?vue&type=script&lang=js&"
export * from "./VoiceRecorder.vue?vue&type=script&lang=js&"
import style0 from "./VoiceRecorder.vue?vue&type=style&index=0&id=1986d224&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986d224",
  null
  
)

export default component.exports